// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthPage_container__3hQ5T","formWrapper":"AuthPage_formWrapper__2ViAp","bottomRight":"AuthPage_bottomRight__3wbQw"};